import React from 'react';
import useDocumentManager from '../../hooks/useDocumentManager';

/**
 * Debug component to display document state
 */
function DocumentDebug() {
  const {
    documents,
    activeDocument,
    isLoading,
    error,
    createDocument,
    closeDocument
  } = useDocumentManager();

  return (
    <div style={{ 
      padding: '20px', 
      margin: '20px', 
      border: '1px solid #ccc',
      borderRadius: '4px',
      backgroundColor: '#f5f5f5'
    }}>
      <h2>Document Debug</h2>
      
      {isLoading ? (
        <p>Loading...</p>
      ) : (
        <>
          <div>
            <h3>Open Documents ({documents.length})</h3>
            <ul>
              {documents.map(doc => (
                <li key={doc.id} style={{ 
                  marginBottom: '10px',
                  padding: '5px',
                  borderLeft: `4px solid ${doc.colorCode}`,
                  backgroundColor: doc.id === activeDocument?.id ? '#e0e0e0' : 'transparent'
                }}>
                  <div><strong>Title:</strong> {doc.title}</div>
                  <div><strong>ID:</strong> {doc.id}</div>
                  <div><strong>Modified:</strong> {new Date(doc.lastModified).toLocaleString()}</div>
                  <div>
                    <button 
                      onClick={() => closeDocument(doc.id)}
                      style={{ marginTop: '5px' }}
                    >
                      Close
                    </button>
                  </div>
                </li>
              ))}
            </ul>
          </div>
          
          <div style={{ marginTop: '20px' }}>
            <h3>Active Document</h3>
            {activeDocument ? (
              <div>
                <div><strong>Title:</strong> {activeDocument.title}</div>
                <div><strong>Color:</strong> <span style={{ 
                  display: 'inline-block',
                  width: '20px',
                  height: '20px',
                  backgroundColor: activeDocument.colorCode,
                  marginLeft: '5px',
                  borderRadius: '4px'
                }}></span></div>
                <div><strong>Content Preview:</strong></div>
                <div style={{ 
                  marginTop: '5px',
                  padding: '10px',
                  backgroundColor: 'white',
                  border: '1px solid #ccc',
                  borderRadius: '4px',
                  maxHeight: '100px',
                  overflow: 'auto'
                }}>
                  {activeDocument.content.slice(0, 200)}
                  {activeDocument.content.length > 200 ? '...' : ''}
                </div>
              </div>
            ) : (
              <p>No active document</p>
            )}
          </div>
          
          <div style={{ marginTop: '20px' }}>
            <button 
              onClick={() => createDocument({ title: 'Test Document ' + new Date().toLocaleTimeString() })}
            >
              Create Test Document
            </button>
          </div>
          
          {error && (
            <div style={{ 
              marginTop: '20px',
              padding: '10px',
              backgroundColor: '#ffebee',
              color: '#c62828',
              borderRadius: '4px'
            }}>
              <strong>Error:</strong> {error}
            </div>
          )}
        </>
      )}
    </div>
  );
}

export default DocumentDebug;
